import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/vue-select'
import './plugins/vue-katex'
import App from './App.vue'
import router from './router'
import store from './store'
import 'typeface-roboto/index.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
